module.exports = __webpack_public_path__ + "img/1440.985a9e76.jpg";